import { ZodType, z } from 'zod';
import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../constants/constant';
import { PageTexts } from '../i18n';
const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);
export const SendCatalogSchema: ZodType<any> = z.object({
  addressId: z.string().optional(),
  note: z.string().optional(),
});

const selectedAdjustments = z.enum(
  [
    Texts.DOLLAR_OFF,
    Texts.PERCENT_OFF,
    Texts.REMOVE_STANDARD_SHIPPING_CHARGE,
    Texts.REMOVE_EXPEDITED_SHIPPING_CHARGE,
    Texts.REMOVE_ALL_SHIPPING_CHARGES,
  ],
  { required_error: 'Please select an adjustment' },
);

const selectedReason = z.enum(
  [
    Texts.CUSTOMER_SERVICE_ISSUE,
    Texts.CUST_PD_POSTAGE_REFUND,
    Texts.SMART_LABEL_ISSUE,
    Texts.PROBLEMS_WITH_PZ,
    Texts.SHIPPING_ERROR,
  ],
  { required_error: 'Please select a reason' },
);
export const adjustOrderSchema = z.object({
  selectedAdjustment: selectedAdjustments,
  selectedReason: selectedReason,
  notes: z.string().min(1, 'Please enter a note'),
  dollarAmount: z.string().min(1, 'Please enter an amount').max(10, { message: 'Maximum length exceeded' }).optional(),
  percentAmount: z.string().min(1, 'Please enter an amount').max(10, { message: 'Maximum length exceeded' }).optional(),
  shippingAmount: z
    .string()
    .min(1, 'Please enter an amount')
    .max(10, { message: 'Maximum length exceeded' })
    .optional(),
});
